import { QuestionNode, IInputNode, isValidNumber } from '../../../actionCard'

export class DropdownQuestionNode extends QuestionNode implements IInputNode<number | undefined> {
  public override setValue(value?: number): void {
    const options = (this.data.data ?? []) as any[]
    if (!options.length) {
      super.setValue()
      return
    }

    const doesOptionExist = options.some(x => x.id === value)
    super.setValue(doesOptionExist ? value : undefined)
  }

  public override setStringValue(value?: string): void {
    const parsedValue = Number.parseFloat(value ?? '')
    this.setValue(isNaN(parsedValue) ? undefined : parsedValue)
  }

  public override stringifyValue(): string {
    const value = this.getValue()
    if (!value && value !== 0) {
      return ''
    }

    const options = (this.data.data ?? []) as any[]
    if (!options.length) {
      return ''
    }
    const optionId = value as number
    return options.find(x => x.id === optionId)?.name || ''
  }

  public override isInputEmpty(): boolean {
    return !isValidNumber(this.getValue())
  }
}
